/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WatchlistModelListResult } from '../../models/watchlist-model-list-result';

export interface ApiWatchlistGet$Any$Params {
  UserId?: number;
}

export function apiWatchlistGet$Any(http: HttpClient, rootUrl: string, params?: ApiWatchlistGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<WatchlistModelListResult>> {
  const rb = new RequestBuilder(rootUrl, apiWatchlistGet$Any.PATH, 'get');
  if (params) {
    rb.query('UserId', params.UserId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WatchlistModelListResult>;
    })
  );
}

apiWatchlistGet$Any.PATH = '/api/watchlist';
